<main id="content-page" style="padding-bottom: 3000px">
    <div class="container main-panel">
        <app-header-ad [position]="'top'"></app-header-ad>

        <div class="row article-row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="article-inner-container" style="margin-left: 15px; padding-right: 20px">
                    <h1>Research Index <i [ngStyle]="{display: getRetrievedStyle()}"
                            style="color: #337ab7; font-weight: 800; font-size: 22px; margin-left: 20px"
                            class="fa fa-spinner fa-spin"></i></h1>

                    <div *ngIf="concepts" class="row">
                        <div class="col-md-12" style="margin-top: 5px">
                            <span *ngFor="let letter of alphabet">
                                <a [routerLink]="" (click)="getResearchIndex(letter)"
                                    style="font-weight: 800; font-size: large">
                                    {{letter}}
                                </a>
                                &nbsp;
                            </span>
                        </div>
                    </div>
                    <div *ngIf="concepts" class="row">
                        <div class="col-md-6">
                            <input (change)="searchForTerm(searchFilter)" #searchFilter id="typeahead-http" type="text"
                                class="form-control" value="{{concepts.searchTerm}}"
                                [resultFormatter]="resultFormatBandListValue"
                                [inputFormatter]="inputFormatBandListValue" [class.is-invalid]="searchFailed"
                                [(ngModel)]="model" [ngbTypeahead]="search" placeholder="search"
                                style="margin-bottom: 50px; padding-top: 6px" />
                        </div>
                    </div>
                    <span *ngIf="concepts">
                        <div *ngFor="let aConcept of concepts.concepts" class="row">
                            <app-research-index-entry style="width: 100%" [concept]="aConcept">
                            </app-research-index-entry>
                        </div>
                    </span>
                    <br />
                    <button *ngIf="concepts && concepts.hasMore" (click)="getMoreConcepts(searchFilter)"
                        class="btn btn-info" href='' style="font-weight: 800; font-size: large">
                        Show More
                    </button>
                    <i *ngIf="concepts" [ngStyle]="{display: getRetrievedStyle()}"
                        style="color: #337ab7; font-weight: 800; font-size: 22px; margin-left: 20px"
                        class="fa fa-spinner fa-spin"></i>
                </div>
            </div>
        </div>
        <P></P>
    </div>
</main>